import React from "react";
import { Button } from "react-bootstrap";
import { SurveyStatusItemDto } from "../../../../interfaces/survey/SurveyDtos";
import Adminrequeststab from "../../adminRequestsTab/AdminRequestsTab";
import AvatarImage from "../../../ui/Avatar/AvatarImage";

interface HomeEmergencyTabProps {
    surveys: SurveyStatusItemDto[];
    highestRole: string;
    onStartSurvey: (surveyName: string, instanceId: string, participant_ID: string) => void;
    limit?: number;
}

const HomeEmergencyTab: React.FC<HomeEmergencyTabProps> = ({
    surveys,
    highestRole,
    onStartSurvey,
    limit = 4
}) => {
    if (highestRole !== "SC" && highestRole !== "SUPERVISOR" && highestRole !== "PROGRAM MANAGER") {
        return <Adminrequeststab />;
    }

    return (
        <div className="common_content_inner mby_t_24">
            <div className="task-list-container">
                {surveys.length === 0 ? (
                    <div
                        className="d-flex flex-column align-items-center justify-content-center p-5 bg-light rounded"
                        style={{ border: "2px dashed #dee2e6", opacity: 0.8 }}
                    >
                        <span className="badge bg-primary mb-3 px-3 py-2">COMING SOON</span>
                        <h5 className="text-secondary fw-bold mb-1">Emergency Surveys</h5>
                        <p className="text-muted mb-0 text-center" style={{ maxWidth: "300px" }}>
                            We are working on bringing emergency survey management to this dashboard.
                        </p>
                    </div>        //   <div className="text-center p-4">No Data Found</div>
                ) : (
                    surveys.slice(0, limit).map((item, index) => {
                        let statusLabel;
                        let actionLabel;
                        switch (item.status) {
                            case "Sent":
                                statusLabel = <p>Not Started</p>;
                                actionLabel = (
                                    <Button variant="primary" className="btn_sm" onClick={() => onStartSurvey(item.surveyName, item.instanceId, item.participantId)}>
                                        Start
                                    </Button>
                                );
                                break;
                            case "Responded":
                                statusLabel = <p>Completed</p>;
                                actionLabel = (
                                    <Button variant="secondary" className="btn_sm" onClick={() => onStartSurvey(item.surveyName, item.instanceId, item.participantId)}>
                                        View
                                    </Button>
                                );
                                break;
                            default:
                                statusLabel = <p>{item.status}</p>;
                                actionLabel = null;
                        }
                        return (
                            <div className="task-card" key={index}>
                                <div className="task-card-content">
                                    <div className="task-info-left">
                                        <span className="top-header">{item.surveyTitle}</span>
                                        <span>{item.surveyName}</span>
                                    </div>
                                    <div className="task-info-right">
                                        <div className="flex items-center gap-1">
                                            <div className="task-assignees">
                                                <div className="flex items-center gap-1">
                                                    <AvatarImage key={index} className="max-w-[1.3rem] max-h-[1.3rem]" userId={""} size={"xxs"} />
                                                    <span className="task-assignees flex items-center gap-1">{item.participantName}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <span>{item.status}</span>
                                        <span>{actionLabel}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default HomeEmergencyTab;